








































import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import * as service from '@/services/delivery-address';
import * as resize from '@/subjects/resize';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {
    ListMessages,
  }
})
export default class DeliveryAddressHistButton extends BaseComponent {
  @Prop()
  public ids;
  @Prop()
  public nomeUnidade;
  @Prop()
  public descricao;

  public histHeaders: any = [
    { text: 'Data', value: 'data', sortable: true },
    { text: 'Usuário', value: 'usuario', sortable: false },
    { text: 'Ação', value: 'status', sortable: false },
    { text: 'Justificativa', value: 'justificativa', sortable: false }
  ];

  private historicoExibindo: any[] = [];
  private historicoError: boolean = false;
  private carregandoHistorico: boolean = false;

  smallScreen: boolean = resize.isXsOrSmSizeScreen();

  public buscarHistorico(): void {
    this.historicoError = false;
    this.carregandoHistorico = true;

    this.historicoExibindo = [];
    this.addSubsc(
      service.listDeliveryAddressHist(this.ids).subscribe(
        (lista) => {
          this.carregandoHistorico = false;
          this.historicoExibindo = lista;
        },
        (error) => {
          this.carregandoHistorico = false;
          this.historicoError = true;
        }
      )
    );
  }
}
